"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var cache_service_1 = require("./cache.service");
var CacheModule = /** @class */ (function () {
    function CacheModule() {
    }
    CacheModule.decorators = [
        { type: core_1.NgModule, args: [{
                    providers: [
                        cache_service_1.CacheService
                    ]
                },] },
    ];
    /** @nocollapse */
    CacheModule.ctorParameters = function () { return []; };
    return CacheModule;
}());
exports.CacheModule = CacheModule;
//# sourceMappingURL=cache.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/obscache/dist/cache.module.js
// module id = 167
// module chunks = 0